import { userLogout, reg } from "@/api/login";
import { Local } from '@/utils/storage';
import { Message } from "element-ui";
import { IS_SSO } from '@/const/const';
import ServerConstants from '@/api/login/server';

const userInfo = Local.get('user_info');

const UserModule= {
    namespaced: true,
    state: {
        token: userInfo ? userInfo.token : '',
        options: [],
        commentCount: 0,
        userTutorials: Local.get('userTutorials'),
        teamId: '', // 用户当前团队ID
        teamName: '', // 用户当前团队名称
        isOwner: false, // 是否是团队所有者
        teamPermissions: {
            isView: false, // 是否有查看权限
            isEdit: false, // 是否有编辑权限
            isDelete: false, // 是否有删除权限
        },
    },
    mutations: {
        SET_COMMENT_COUNT: (state,count) => {
            state.commentCount = count;
        },
        setToken( state, token) {
            state.token = token;
        },
        removeToken( state) {
            state.token = null;
        },
        // 设置用户信息
        setUserInfo(state, info) {
            Local.set('user_info', info);
            Local.set('username', info.user_name);
        },
        // 删除用户信息
        removeUserInfo(state) {
            Local.remove('user_info');
            Local.remove('username');
            state.teamId = '';
            state.teamName = '';
            state.teamPermissions.isView = false;
            state.teamPermissions.isEdit = false;
            state.teamPermissions.isDelete = false;
            state.isOwner = false;
        },
        // 用户导航
        setUserTutorials() {
            Local.set('userTutorials', true);
        },
        removeUserTutorials() {
            Local.remove('userTutorials');
        },

        /**
         * 设置用户当前团队ID
         * @param {*} teamId 
         */
        setTeamInfo( state, data) {
            state.teamId = data.id;
            state.teamName = data.name;
            state.teamPermissions.isView = data.isView || false;
            state.teamPermissions.isEdit = data.isEdit || false;
            state.teamPermissions.isDelete = data.isDelete || false;
            state.isOwner = data.isOwner;
        },
    },
    actions: {
        setTokenA({ commit }, data) {
            commit('setToken', data);
        },
        setUserInfoA({ commit }, data) {
            commit('setUserInfo', data);
        },
        changeTeam({ commit }, data) {
            commit('setTeamInfo', data);
        },

        async logout(context) {
            const user_uuid = Local.get('userUuid');
            // 清理本地认证状态
            context.commit('removeUserInfo');
            context.commit('removeToken');
            context.commit('removeUserTutorials');
            //保存上一个退出用户的uuid
            Local.set('userUuid',user_uuid);

            if (!IS_SSO) {
                await userLogout();
            } else {
                // SSO 模式：用 replace 跳转 Auth GET /sso/logout 清除 Spring Security Session，
                // Auth 清除后 302 回 Celelens-app，路由守卫检测无 token → 重新走 authorize → 无 session → 跳登录页
                // 调用方在 SSO 模式下不得再执行 router.push，否则路由守卫的
                // buildAuthorizeUrl().then(url => window.location.replace(url)) 会覆盖此导航
                const redirectUri = window.location.origin + '/';
                window.location.replace(ServerConstants.SSO_LOGOUT_URL
                    + '?redirect_uri=' + encodeURIComponent(redirectUri));
            }
        },
        async reg({commit}, userInfo) {
            const serverdata = await reg(userInfo);
            if(!serverdata.data) {
                throw serverdata.msg;
            }
            if(Number(serverdata.code) === 200) {
                Message.success('Registration successful');
            } else {
                throw 'Registration failed';
            }
        },
    },
};

export default UserModule;
